import { createGlobalStyle } from 'styled-components';

const GlobalFont = createGlobalStyle`

  body, input, textarea{
    font-family: "Everett-Light" !important;
    background-color: #19191B;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    line-height: 1.15;
    margin: 0;
  }

  body {
    width: 100%;
    max-width:1280px;
    margin:0 auto;
    padding: 0px 30px;
    overflow-x: hidden;
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;   /* Firefox, other Gecko */
    box-sizing: border-box;
  }

  h1, h2 {
    font-family: "Recife-Display" !important;
    color: #19191B;
    font-weight: 100;
  }

`;

export default GlobalFont;
